import React, { useMemo } from 'react';

import EnhancedBackdrop from '@components/common/EnhancedBackdrop';
import { Backdrop, Dialog, DialogProps } from '@mui/material';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

export interface IEnhancedDialogProps extends DialogProps {
  blur?: boolean;
  dialogClassName?: string;
}

const useStyles = makeStyles()(() => ({
  modalDocument: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }
}));

const EnhancedDialog: React.FC<IEnhancedDialogProps> = ({
  open = false,
  children,
  onClose,
  blur = false,
  dialogClassName,
  ...props
}) => {
  const { classes } = useStyles();

  const slots = useMemo(
    () => ({
      backdrop: blur ? EnhancedBackdrop : Backdrop
    }),
    [blur]
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slots={slots}
      fullWidth
      transitionDuration={500}
      scroll="body"
      maxWidth="xl"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      disableEnforceFocus // to fix the issue of unfocusable fields when we have dialog inside dialog
    >
      <section className={clsx(classes.modalDocument, dialogClassName)}>
        {children}
      </section>
    </Dialog>
  );
};

export default EnhancedDialog;
